<template>
  <facquick-card title="Ledger Accounts">
    <template v-slot:header-actions>
      <v-btn color="primary" icon class="elevation-3" @click="showLa=!showLa">
        <v-icon>add</v-icon>
      </v-btn>

      <v-spacer></v-spacer>
       <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            style="max-width:40%"
          ></v-text-field>
    </template>
    <template v-slot:card-content>
      <v-data-table
        :headers="ledger_acc_headers"
        :items="ledgeraccs"
        class="elevation-0"
        :search="search"
      >
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.type }}</td>
          <td class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs6>
                <v-btn flat icon color="blue" @click="editledgeracc(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs6>
                <v-btn
                  flat
                  icon
                  color="pink"
                  @click="deleteledgeracc(props.item, props.item.index)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </td>
        </template>
      </v-data-table>

      <m-dialog title="Ledger Account" :show="showLa" pers>
        <template v-slot:header-actions>
          <v-btn @click="showLa=!showLa" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <v-form ref="form">
            <v-autocomplete
              :items="['income','expense']"
              label="Type"
              v-model="ledgeracc_model.type"
              :rules="validRules.required"
            />

            <v-text-field label="Name" v-model="ledgeracc_model.name" :rules="validRules.required" />
          </v-form>
        </template>

        <template v-slot:footer-actions>
          <v-btn style="cursor:pointer" color="success" @click="saveledgeracc()">save</v-btn>
          <v-btn @click="showLa=!showLa" style="cursor:pointer" color="error">close</v-btn>
        </template>
      </m-dialog>
    </template>
  </facquick-card>
</template>

<script>
import { mapGetters } from "vuex";
import QuickCard from "../Quickcard";
import Mdialog from "../Modal";
export default {
  name: "ledger-accounts",
  components: {
    "facquick-card": QuickCard,
    "m-dialog": Mdialog
  },
  data() {
    return {
      showL: false,
      showLa: false,
      pers: false,
      search: "",
      editedIndex: -1,
      ledgeracc_model: {
        type: "",
        name: ""
      },

      ledger_acc_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn"
        },
        {
          text: "Name",
          align: "center",
          sortable: false,
          value: "name"
        },
        {
          text: "Type",
          align: "center",
          sortable: false,
          value: "type"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("ledgeraccs/getAll");

    //console.log("ledgeraccsooooo",ledgeraccs)
  },
  computed: {
    ...mapGetters({
      ledgeraccs: "ledgeraccs/LEDGERACCS",
      laerrors: "ledgeraccs/LEDGERACC_ERROR",
      loading: "ledgeraccs/LEDGERACC_LOADING"
    })
  },
  methods: {
    addledgeracc() {
      this.$store.dispatch("ledgeraccs/add", this.ledgeracc_model);

      if (this.laerrors == null) {
        this.ledgeracc_model = {
          name: "",
          type: ""
        };
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Ledger Account created successfully",
          title: "Additional Ledger Accounts",
          modal: false
        });
      }
    },
    deleteledgeracc(ledgeracc, index) {
      if (confirm("Are you sure you want to delete this ledgeracc?")) {
        this.$store.dispatch("ledgeraccs/delete", { ledgeracc, index });
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Ledger Account deleted successfully",
          title: "Additional Ledger Accounts",
          modal: false
        });
      }
    },

    editledgeracc(ledgeracc) {
      this.editedIndex = this.ledgeraccs.indexOf(ledgeracc);
      this.ledgeracc_model = Object.assign({}, ledgeracc);

      //alert(this.editedIndex)

      this.showLa = true;
    },
    updateledgeracc(ledgeracc, index) {
      this.$store.dispatch("ledgeraccs/update", { index, ledgeracc });

      if (this.laerrors == null) {
        this.ledgeracc_model = {
          name: "",
          type: ""
        };
        this.editedIndex = -1;
        this.showLa = false;
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Ledger Account updated successfully",
          title: "Additional Ledger Accounts",
          modal: false
        });
      }
    },
    saveledgeracc() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing ledgeracc info or saving ledgeracc info
      if (this.editedIndex > -1) {
        this.updateledgeracc(this.ledgeracc_model, this.editedIndex);
      } else {
        this.addledgeracc();
      }
    }
  },
  watch: {
    showL(val) {
      if (val == false) {
        this.ledgeracc_model = {
          name: "",
          type: ""
        };
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/ledgeraccs.vue